import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import Container from '../../container';
import Story from '../../story';
import Subhead from '../../subhead';
import RenderMd from '../../render-md';

const AboutStory = props => (
  <StorySection id={props.id}>
    <Container>

      <Story
        image={props.image}
        videoLink={props.videoLink}
      >
        <Subhead>{props.subheading}</Subhead>
        <StoryHeadline>{props.title}</StoryHeadline>
        <RenderMd source={props.content} />
      </Story>

    </Container>
  </StorySection>
);

const StorySection = styled.section`
  padding: 200px 0 160px;
  background-color: ${props => props.theme.lightGray};

  ${screen.below(bp.desktop, `
    padding: 200px 0 120px;
  `)}

  ${screen.below(bp.laptopSm, `
    padding: 200px 0 100px;
  `)}

  ${screen.below(bp.tablet, `
    padding: 200px 0 80px;
  `)}

  ${screen.below(bp.mobile, `
    padding: 100px 0 60px;
  `)}
`;

const StoryHeadline = styled.h3`
  ${screen.below(bp.mobile, `
    max-width: 192px;
    font-size: ${rem(27)};
  `)};
`;

AboutStory.propTypes = {
  subheading: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.object,
  videoLink: PropTypes.string,
  id: PropTypes.string,
};

export default AboutStory;
